export const REGISTER_MAPPING = 'URL/REGISTER_MAPPING'
